// src/pages/tickets/components/TicketHeader.tsx
import { Link } from 'react-router-dom';
import { Badge, StatusBadge, PriorityBadge, Button } from '@/components/ui';
import { ArrowLeft, Edit } from 'lucide-react';
import type { Ticket } from '@/types';

interface Props {
  ticket: Ticket;
  onEdit: () => void;
}

const TIPO_LABELS: Record<string, string> = {
  INCIDENTE: 'Incidente',
  REQUERIMIENTO: 'Requerimiento',
  DUDA: 'Duda',
};

export function TicketHeader({ ticket, onEdit }: Props) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-4">
          <Link to="/tickets" className="text-gray-500 hover:text-gray-700 mt-1">
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <div>
            <div className="flex items-center gap-3 mb-2">
              <h1 className="text-2xl font-bold">#{ticket.numero}</h1>
              <Badge variant="default">{TIPO_LABELS[ticket.tipo]}</Badge>
              <StatusBadge status={ticket.estado} />
              <PriorityBadge priority={ticket.prioridad} />
            </div>
            <h2 className="text-lg text-gray-700">{ticket.titulo}</h2>
            {ticket.descripcion && (
              <p className="text-gray-500 mt-2 whitespace-pre-wrap">{ticket.descripcion}</p>
            )}
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={onEdit}>
            <Edit className="h-4 w-4 mr-1" />
            Editar
          </Button>
        </div>
      </div>
    </div>
  );
}
